$(document).ready(function () {
  function adjustBlockHeights() {
    if ($(window).width() >= 989) {
      var maxHeight = 0;
      $(".template-page-industrial .multicolumn_title-btn-wrapper").each(
        function () {
          var blockHeight = $(this).height();
          if (blockHeight > maxHeight) {
            maxHeight = blockHeight;
          }
        }
      );
      $(".template-page-industrial .multicolumn_title-btn-wrapper").height(
        maxHeight
      );
    } else {
      $(".template-page-industrial .multicolumn_title-btn-wrapper").height(
        "auto"
      );
    }
  }
  adjustBlockHeights();
  $(window).resize(function () {
    adjustBlockHeights();
  });
  $(document).on(
    "click",
    ".read_more_with_content a.read_more_btn",
    function (e) {
      e.preventDefault();
      if ($(this).text() == "Read More >>") {
        $(this)
          .parents(".read_more_with_content")
          .find(".read_more_content_here")
          .slideDown();
        $(this).text("Read Less >>");
      } else {
        $(this)
          .parents(".read_more_with_content")
          .find(".read_more_content_here")
          .slideUp();
        $(this).text("Read More >>");
      }
    }
  );
  $(document).on("click", "a.button.videoButton.primaryButton", function (e) {
    e.preventDefault();
    var video_url_btn = $(this).data("video-url");
    $(this)
      .parents(".banner_outer_main_wrapp")
      .find(".videoContainer video")
      .attr("src", video_url_btn);
    $(this).parents(".banner_outer_main_wrapp").find(".videoContainer").show();
    $(this)
      .parents(".banner_outer_main_wrapp")
      .find(".videoContainer video")
      .trigger("play");
  });
  $(document).on("click", ".videoCloseButton", function (e) {
    e.preventDefault();
    $(this).parents(".videoContainer").find("video").removeAttr("src");
    $(this).parents(".videoContainer").find("video").trigger("pause");
    $(this).parents(".videoContainer").hide();
  });
  $(document).on("click", ".laboratories_page_side a", function (e) {
    e.preventDefault();
    var side_data_handle = $(this).attr("data-handle");
    $("html, body").animate(
      {
        scrollTop: $(
          ".side_bottom_rpeater_wrapp[data-handle='" + side_data_handle + "']"
        ).offset().top,
      },
      1200
    );
  });
  $(document).on(
    "click",
    ".custom-video-buttons.custom-left-right-buttons.new-power_all_btns a",
    function () {
      var data_handle = $(this).data("handle");
      var data_handle_2 = $(
        ".scrolling_bottom_sections[data-handle='" + data_handle + "']"
      ).html();
      if (typeof data_handle_2 !== "undefined") {
        $("html, body").animate(
          {
            scrollTop: $(
              ".scrolling_bottom_sections[data-handle='" + data_handle + "']"
            ).offset().top,
          },
          1200
        );
      }
    }
  );
  $(".custom_accent_col-banner .custom-video-buttons a").click(function (e) {
    e.preventDefault();
    var link_handle = $(this).attr("data-handle");
    $("html, body").animate(
      {
        scrollTop: $(
          ".custom_collection_progrid-outer[data-id='" + link_handle + "']"
        ).offset().top,
      },
      1200
    );
  });

  $(document).on(
    "click",
    ".everywhere-busstrut-heading-col h2 a",
    function (e) {
      var get_link_href = $(this).attr("href");
      if (get_link_href == "#viewemail") {
        e.preventDefault();
        gtag("event", "view_email", {
          event_category: "Email",
          event_label: "Email Clicked",
          value: 1,
        });
      }
    }
  );

  function forceVideoPlay() {
    const homeVideos = document.querySelectorAll(".template-index video");
    homeVideos.forEach((video) => {
      if (video && video.paused) {
        video.play().catch((err) => {
          console.warn("Autoplay failed:", err);
        });
      }
    });
  }

  document.addEventListener("DOMContentLoaded", forceVideoPlay);
  const observer = new MutationObserver(forceVideoPlay);
  observer.observe(document.body, { childList: true, subtree: true });

  // var defaultVariantId = $('.new-home-img-label[checked]').data('variant-id');

  // if (defaultVariantId) {
  //   $('.variant-diagram').hide();
  //   $('.variant-diagram[data-variant-img-id="' + defaultVariantId + '"]').show();
  // }

  // $(document).on('click', '.new-home-img-label', function (e) {
  //   // e.preventDefault();
  //   var selectedVariantId = $(this).data('variant-id');
  //  // $('.home-variant-radios').removeAttr("checked");
  //  //  $(this).prev('input[type=radio]').attr('checked', 'checked');
  //  //  $('.home-variant-radios').trigger("change");
  //   console.log("Selected Variant ID:", selectedVariantId);

  //   $('.variant-diagram').hide();
  //   $('.variant-diagram[data-variant-img-id="' + selectedVariantId + '"]').fadeIn();
  // });
});




    // // Toggle popup on button click
    // $('.custom_heading_wrapper').on('click', function(){
    //   $('.email-popup').show();
    // });

    // // Hide popup if clicking anywhere outside
    // $(document).on('click', function(e){
    //   if (!$(e.target).closest('.custom_heading_wrapper').length) {
    //     $('.email-popup').hide();
    //   }
    // });


  // Toggle popup on button click
  $('.custom_heading_wrapper').on('click', function(){

    const popup = $(this).find('.email-popup');

    // Toggle: If visible, hide it; otherwise, show it
    if (popup.is(':visible')) {
      popup.hide();
    } else {
      $('.email-popup').hide(); // close other popups if any
      popup.show();
    }
  });

  // Hide popup if clicking anywhere outside
  $(document).on('click', function(e){
    if (!$(e.target).closest('.custom_heading_wrapper').length) {
      $('.email-popup').hide();
    }
  });


